// import { motion } from 'framer-motion'
// import { Trophy, Activity, Shield, Calendar } from 'lucide-react'
// import SidebarGalleryPage from '../Main/Sidebargallery'
// import sport1 from '../../assets/facilities/sport1.jpg'
// import sport2 from '../../assets/facilities/sport2.jpg'
// import sport3 from '../../assets/facilities/sport3.jpg'

// const sportsActivities = {
//   quote: "A healthy mind keeps in healthy body.",
//   description: "Keeping this fact The sports committee organizes various sports activities during annual function. The committee is selected to provide sports facilities to the students. Various sports activities like Table Tennis, Badminton, Chess, Carrom, Discuss throw, motion, Chess, Carrom, Discus throw, Javelin throw, Hammer throw etc. are being conducted in college campus. All students are free to participate in the activities of their choice. The committee also conducts inter class competitions from time to time.",
//   selfDefense: "As the self defense is essential for women empowerment. Hence the committee conducts self defence training camp time to time at free of cost.",
//   specialEvents: "On the occasion of Youth day and World Yoga day committee organizes Yoga camp for students and College Staff.",
//   activities: [
//     "BED MINTON",
//     "Basket Ball",
//     "DISCUS THROW",
//   ]
// }


// export default function SportsSection() {
//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//       {/* Main Content */}
//       <div className="max-w-7xl mx-auto md:p-6 flex flex-col lg:flex-row gap-8">
//         {/* Left Column - Sports Section */}
//         <motion.div 
//           className="lg:w-2/3"
//           initial={{ opacity: 0, x: -20 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.5 }}
//         >
//           <div className="space-y-6">
//             {/* <div className="aspect-video relative overflow-hidden rounded-lg">
//               <img 
//                 src="/placeholder.svg?height=400&width=600"
//                 alt="Students participating in sports activities"
//                 className="object-cover w-full h-full"
//               />
//             </div> */}
            
//               <div className="border-[#00BFA5] border-4 rounded-md p-2">
//               <h2 className="text-xl font-bold mb-4 flex items-center gap-2 bg-[#00BFA5] text-white p-2 rounded-sm">
//                 <Trophy className="w-6 h-6" />
//                 Sports Zone and Activities
//               </h2>
//               <div className="space-y-4">
//                 <motion.div
//                   initial={{ opacity: 0 }}
//                   animate={{ opacity: 1 }}
//                   transition={{ delay: 0.2 }}
//                   className="italic"
//                 >
//                   <q>{sportsActivities.quote}</q>
//                 </motion.div>
                
//                 <motion.p
//                   initial={{ opacity: 0 }}
//                   animate={{ opacity: 1 }}
//                   transition={{ delay: 0.3 }}
//                 >
//                   {sportsActivities.description}
//                 </motion.p>

//                 <motion.div
//                   initial={{ opacity: 0 }}
//                   animate={{ opacity: 1 }}
//                   transition={{ delay: 0.4 }}
//                   className="flex items-start gap-2"
//                 >
//                   <Shield className="w-5 h-5 mt-1 flex-shrink-0" />
//                   <p>{sportsActivities.selfDefense}</p>
//                 </motion.div>

//                 <motion.div
//                   initial={{ opacity: 0 }}
//                   animate={{ opacity: 1 }}
//                   transition={{ delay: 0.5 }}
//                   className="flex items-start gap-2"
//                 >
//                   <Calendar className="w-5 h-5 mt-1 flex-shrink-0" />
//                   <p>{sportsActivities.specialEvents}</p>
//                 </motion.div>
//                 </div>
//             </div>
//             <div className="space-y-4  p-2 rounded-lg border-[#00BFA5] border-4">
//                   <h3 className="font-bold mb-2 bg-[#00BFA5] text-white p-2 rounded-sm">ACTIVITIES</h3>
//                   <ul className="grid grid-cols-2 gap-2">
//                     {sportsActivities.activities.map((activity, index) => (
//                       <motion.li
//                         key={index}
//                         initial={{ opacity: 0, x: -20 }}
//                         animate={{ opacity: 1, x: 0 }}
//                         transition={{ delay: 0.6 + index * 0.1 }}
//                         className="flex items-center gap-2 bg-white p-4 rounded-lg"
//                       >
//                         <Activity className="w-4 h-4" />
//                         {activity}
//                       </motion.li>
//                     ))}
//                   </ul>
//                 </div>
//               </div>
//               <div>
//                 <img 
//                   src={sport1}
//                   alt="Student participating in sports activities"
//                   className="object-cover w-full h-full"
//                 />
//               </div>
//               <div>
//                 <img 
//                   src={sport2}
//                   alt="Student participating in sports activities"
//                   className="object-cover w-full h-full"
//                 />
//               </div>
//               <div>
//                 <img 
//                   src={sport3}
//                   alt="Student participating in sports activities"
//                   className="object-cover w-full h-full"
//                 />
//               </div>
//         </motion.div>

//         {/* Right Column - Gallery */}
//        <SidebarGalleryPage></SidebarGalleryPage>
//       </div>
//     </div>
//   )
// }
import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, Activity, Shield, Calendar } from 'lucide-react';
// import SidebarGalleryPage from '../Main/Sidebargallery';
import sport1 from '../../assets/facilities/sport1.jpg';
import sport2 from '../../assets/facilities/sport2.jpg';
import sport3 from '../../assets/facilities/sport3.jpg';

const sportsActivities = {
  quote: "A healthy mind keeps in healthy body.",
  description:
    "Keeping this fact The sports committee organizes various sports activities during annual function. The committee is selected to provide sports facilities to the students. Various sports activities like Table Tennis, Badminton, Chess, Carrom, Discuss throw, motion, Chess, Carrom, Discus throw, Javelin throw, Hammer throw etc. are being conducted in college campus. All students are free to participate in the activities of their choice. The committee also conducts inter class competitions from time to time.",
  selfDefense:
    "As the self defense is essential for women empowerment. Hence the committee conducts self defence training camp time to time at free of cost.",
  specialEvents:
    "On the occasion of Youth day and World Yoga day committee organizes Yoga camp for students and College Staff.",
  activities: ["BED MINTON", "Basket Ball", "DISCUS THROW" ,"PITTHU" ,"KHO-KHO"],
};

export default function SportsSection() {
  return (
    <div className="min-h-screen bg-gray-50 p-12">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-10">
        {/* Left Column */}
        <motion.div
          className="lg:w-2/3 space-y-8"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* Sports Info Section */}
          <div className="bg-white p-2 border-4 border-[#00BFA5] rounded-lg shadow-lg space-y-2">
            <h2 className="text-xl font-bold flex items-center  bg-[#00BFA5] text-white p-3 rounded-sm">
              <Trophy className="w-6 h-6" />
              Sports Zone and Activities
            </h2>
            <motion.div
              className="italic text-gray-700 ml-2"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2 }}
            >
              <q>{sportsActivities.quote}</q>
            </motion.div>
            <motion.p
              className="text-gray-600 p-2"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              {sportsActivities.description}
            </motion.p>
            <motion.div
              className="flex items-start p-2 gap-3"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.4 }}
            >
              <Shield className="w-6 h-6 text-[#00BFA5]" />
              <p className="text-gray-600">{sportsActivities.selfDefense}</p>
            </motion.div>
            <motion.div
              className="flex items-start p-2 gap-3"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
            >
              <Calendar className="w-6 h-6 text-[#00BFA5]" />
              <p className="text-gray-600">{sportsActivities.specialEvents}</p>
            </motion.div>
          </div>

          {/* Activities Section */}
          <div className="bg-white p-2 border-4 border-[#00BFA5] rounded-lg shadow-lg">
            <h3 className="text-lg font-bold bg-[#00BFA5] text-white p-3 rounded-sm">
              Activities
            </h3>
            <ul className="grid grid-cols-2 gap-4 mt-4">
              {sportsActivities.activities.map((activity, index) => (
                <motion.li
                  key={index}
                  className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg shadow"
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.6 + index * 0.1 }}
                >
                  <Activity className="w-5 h-5 text-[#00BFA5]" />
                  <span className="text-gray-700">{activity}</span>
                </motion.li>
              ))}
            </ul>
          </div>
        </motion.div>

        {/* Right Column - Image Gallery */}
        <motion.div
          className="lg:w-1/3"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="space-y-6 ">
            {[sport1, sport2, sport3].map((image, index) => (
              <div
                key={index}
                className="relative h-64 rounded-lg overflow-hidden shadow-lg"
              >
                <motion.img
                  src={image}
                  alt={`Sport ${index + 1}`}
                  className="object-cover w-full h-full"
                  initial={{ scale: 1.05 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5 }}
                />
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
}
